import type { ModelInstanceFormValues } from '@/delivery-type-plugin/capabilities/maas-model-storage/modelInstanceTypes';

/** 是否勾选「网关节点配置」模块（仅 true 时组装/校验 spec.gateway 与 gatewayNodes） */
export function isMiGatewayModuleEnabled(values: Pick<ModelInstanceFormValues, 'skuResourceModules'> | undefined): boolean {
  return values?.skuResourceModules?.gatewayConfig === true;
}
